<template>
  <div class="form-client-details">
    <p
      class="insurance-chosen-variant__subtitle payment_subtitle">
      Проверьте подготовленный проект договора и оплатите страховую премию удобным для Вас способом
    </p>

    <div class="file-container">
      <a class="file-link" :href="fileSrc" target="_blank">
        <svg xmlns="http://www.w3.org/2000/svg" version="1.1" xmlns:xlink="http://www.w3.org/1999/xlink" width="512"
             height="512" x="0" y="0" viewBox="0 0 512 512" style="enable-background:new 0 0 512 512"
             xml:space="preserve" class=""><g><path d="M106 512h300c24.814 0 45-20.186 45-45V150H346c-24.814 0-45-20.186-45-45V0H106C81.186 0 61 20.186 61 45v422c0 24.814 20.186 45 45 45zm60-301h180c8.291 0 15 6.709 15 15s-6.709 15-15 15H166c-8.291 0-15-6.709-15-15s6.709-15 15-15zm0 60h180c8.291 0 15 6.709 15 15s-6.709 15-15 15H166c-8.291 0-15-6.709-15-15s6.709-15 15-15zm0 60h180c8.291 0 15 6.709 15 15s-6.709 15-15 15H166c-8.291 0-15-6.709-15-15s6.709-15 15-15zm0 60h120c8.291 0 15 6.709 15 15s-6.709 15-15 15H166c-8.291 0-15-6.709-15-15s6.709-15 15-15z" fill="#00b5c2" opacity="1" data-original="#000000" class=""></path><path
          d="M346 120h96.211L331 8.789V105c0 8.276 6.724 15 15 15z" fill="#00b5c2" opacity="1" data-original="#000000"
          class=""></path></g>
        </svg>
        <span class="file-name">
            Пример полиса.pdf
          </span>
        <span class="file-search">
          <svg xmlns="http://www.w3.org/2000/svg" version="1.1" xmlns:xlink="http://www.w3.org/1999/xlink" width="512"
               height="512" x="0" y="0" viewBox="0 0 56.966 56.966" style="enable-background:new 0 0 512 512"
               xml:space="preserve" class=""><g><path d="M55.146 51.887 41.588 37.786A22.926 22.926 0 0 0 46.984 23c0-12.682-10.318-23-23-23s-23 10.318-23 23 10.318 23 23 23c4.761 0 9.298-1.436 13.177-4.162l13.661 14.208c.571.593 1.339.92 2.162.92.779 0 1.518-.297 2.079-.837a3.004 3.004 0 0 0 .083-4.242zM23.984 6c9.374 0 17 7.626 17 17s-7.626 17-17 17-17-7.626-17-17 7.626-17 17-17z" fill="#b4b4b4" opacity="1" data-original="#000000" class=""></path></g></svg>
          посмотреть
        </span>
      </a>

      <a class="file-link" :href="insuranceRulesUrl" target="_blank">
        <svg xmlns="http://www.w3.org/2000/svg" version="1.1" xmlns:xlink="http://www.w3.org/1999/xlink" width="512"
             height="512" x="0" y="0" viewBox="0 0 512 512" style="enable-background:new 0 0 512 512"
             xml:space="preserve" class=""><g><path d="M106 512h300c24.814 0 45-20.186 45-45V150H346c-24.814 0-45-20.186-45-45V0H106C81.186 0 61 20.186 61 45v422c0 24.814 20.186 45 45 45zm60-301h180c8.291 0 15 6.709 15 15s-6.709 15-15 15H166c-8.291 0-15-6.709-15-15s6.709-15 15-15zm0 60h180c8.291 0 15 6.709 15 15s-6.709 15-15 15H166c-8.291 0-15-6.709-15-15s6.709-15 15-15zm0 60h180c8.291 0 15 6.709 15 15s-6.709 15-15 15H166c-8.291 0-15-6.709-15-15s6.709-15 15-15zm0 60h120c8.291 0 15 6.709 15 15s-6.709 15-15 15H166c-8.291 0-15-6.709-15-15s6.709-15 15-15z" fill="#00b5c2" opacity="1" data-original="#000000" class=""></path><path
          d="M346 120h96.211L331 8.789V105c0 8.276 6.724 15 15 15z" fill="#00b5c2" opacity="1" data-original="#000000"
          class=""></path></g>
        </svg>
        <span class="file-name">
            Правила страхования.pdf
          </span>
        <span class="file-search">
          <svg xmlns="http://www.w3.org/2000/svg" version="1.1" xmlns:xlink="http://www.w3.org/1999/xlink" width="512"
               height="512" x="0" y="0" viewBox="0 0 56.966 56.966" style="enable-background:new 0 0 512 512"
               xml:space="preserve" class=""><g><path d="M55.146 51.887 41.588 37.786A22.926 22.926 0 0 0 46.984 23c0-12.682-10.318-23-23-23s-23 10.318-23 23 10.318 23 23 23c4.761 0 9.298-1.436 13.177-4.162l13.661 14.208c.571.593 1.339.92 2.162.92.779 0 1.518-.297 2.079-.837a3.004 3.004 0 0 0 .083-4.242zM23.984 6c9.374 0 17 7.626 17 17s-7.626 17-17 17-17-7.626-17-17 7.626-17 17-17z" fill="#b4b4b4" opacity="1" data-original="#000000" class=""></path></g></svg>
          посмотреть
        </span>
      </a>

    </div>

    <ElForm class="form-property-details__form form"
            ref="paymentFormRef"
    >
    <div class="form-property-details__terms-agree">
        <el-checkbox v-input-id="'payment-terms-correct'" v-model="isCheckedTerm"></el-checkbox>
        <p class="form-property-details__terms-agree-text payment-agree">
          Подтверждаю корректность данных, отраженных в проекте полиса.
        </p>
      </div>
      <div class="form-property-details__terms-agree">
        <el-checkbox v-input-id="'payment-insurance-rules'" v-model="isCheckedTerm2"></el-checkbox>
        <p class="form-property-details__terms-agree-text payment-agree">
          Согласен с
          <a class="form-property-details__terms-agree-text--link payment-link"
             :href="insuranceRulesUrl"
             target="_blank">правилами страхования</a>
        </p>
      </div>
      <div class="form-property-details__terms-agree">
        <el-checkbox v-input-id="'payment-personal-data'" v-model="isCheckedPolicy"></el-checkbox>
        <p class="form-property-details__terms-agree-text payment-agree">
          Я даю <a class="form-property-details__terms-agree-text--link payment-link"
             href="https://zettains.ru/upload/rules/Приложение 9_Согласие для покупки полиса на сайте.pdf"
             target="_blank">согласие</a> на обработку персональных данных в соответствии 
          <br>
          с 
          <a class="form-property-details__terms-agree-text--link payment-link"
             href="https://zettains.ru/company/privacy/"
             target="_blank">политикой в отношении обработки персональных данных</a>
        </p>
      </div>
      <div class="form__buttons form__buttons--margin-small">
        <BaseButton text="Назад"
                    theme="muted"
                    is-text
                    size="large"
                    :is-disabled="btnsDisabled"
                    @click.native="$emit('prev-step')"
        />
        <BaseButton text="Перейти к оплате"
                    size="large"
                    :is-disabled="submitIsDisabled || btnsDisabled"
                    @click.native="onSubmit"/>

      </div>
    </ElForm>
  </div>
</template>

<script>
import {getInsuranceRulesUrl} from '@/utils/insurance-rules';
import BaseButton from '@/components/ui/BaseButton';
import SummaryCard from '@/components/ui/SummaryCard';
import ModalPolicyIssuanceError from '@/components/modals/ModalPolicyIssuanceError';

export default {
  name: 'FormPayment',
  components: {
    BaseButton,
    ModalPolicyIssuanceError,
    SummaryCard,
  },
  props: {
    tariffs: Array,
    countCars: Number,
    fileSrc: String,
    btnsDisabled: Boolean,
  },
  data() {
    return {
      isCheckedTerm: false,
      isCheckedTerm2: false,
      isCheckedPolicy: false,
    }
  },
  methods: {
    onSubmit() {
      this.$emit('result-submit');
    },
  },
  computed: {
    insuranceRulesUrl: getInsuranceRulesUrl,
    submitIsDisabled() {
      return !this.isCheckedTerm || !this.isCheckedTerm2 || !this.isCheckedPolicy;
    },
  },
}
</script>

<style scoped lang=scss>
.form-property-details {
  &__terms-agree {
    margin-top: rem($gap-normal);

    display: flex;

    &-text {
      @include text-normal($font-weight-regular, $line-height-normal);

      margin-left: rem($gap-mini);

      @media #{$screen-medium} {
        font-size: rem($font-size-small);
      }

      @media #{$screen-small} {
        font-size: rem($font-size-mini);
      }

      &--link {
        text-decoration: underline;

        color: inherit;
      }
    }
  }
}

.payment_subtitle {
  margin-top: rem(10px) !important;
  font-size: 1rem !important;
}

.payment-agree {
  font-size: .875rem !important;
}

.payment-link {
  color: #00a1b0 !important;
  font-size: .875rem !important;
}

.file-container {
  margin-top: rem(35px);
  margin-bottom: rem(35px);
  display: flex;
  justify-content: space-between;
  align-items: center;

  @media #{$screen-medium} {
    flex-direction: column;
    align-items: start;
  }
}

.file-link {
  display: grid;
  grid-template-areas: "content sidebar" "content ad";

  @media #{$screen-medium} {
    margin-bottom: 5px;
  }
}

.file-link svg {
  width: 26px; /* Ширина иконки */
  height: 34px; /* Высота иконки */
  margin-right: 8px; /* Отступ между иконкой и текстом */
  grid-area: content;
}

.file-name {
  grid-area: sidebar;
  font-size: .875rem;
  font-weight: bold;
}


.file-search {
  grid-area: ad;
  font-size: rem(9px);
}

.file-search svg {
  grid-area: ad;
  margin-right: 2px;
  width: 9px;
  height: 9px;
}
</style>
